import { request } from "/app/src/lib";
import { history } from "/app/src/store";
import Model from "../model";
import * as actions from "./actions";

class User extends Model {
  login(username, password, errorFunction) {
    let url = this.url();
    this._success = (dispatch, err, res) => {
      let body = res.body;
      const userId = body.current_user.id;
      const userToken = body.current_user.token;
      dispatch(actions.userLoginSuccess(userId, userToken));
    };

    this._failure = (dispatch, err, res) => {
      errorFunction(res);
    };

    return (dispatch) => {
      request
        .post(`${url}/v2/me/login`)
        .accept("application/json")
        .send({
          user_email: username,
          user_password: password,
        })
        .end(this.handleResponse(dispatch));
    };
  }

  logout() {
    return (dispatch) => {
      dispatch(actions.userLogout());
      history.push("/");
    };
  }
}

export default new User();



// WEBPACK FOOTER //
// src/model/User/model.js